import { dangerColor } from "../../material-dashboard-pro-react.jsx";

const colorPickerStyle = {
  popover: {
    position: "absolute",
    zIndex: "2",
  },

  cover: {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  },

  clear: {
    color: dangerColor[0] + " !important",
    cursor: "pointer",
  },
  buttonBar: {
    background: "#ffffff",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 2px, rgba(0, 0, 0, 0.3) 0px 4px 8px",
    borderRadius: "0px 0px 2px 2px",
    textAlign: "center",
  },
};

export default colorPickerStyle;
